import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { connect } from 'react-redux'

import { hideMigrationScreen } from 'state/actions/migration_screen'

import { setNewsCounter } from 'helpers/web_to_client'

import Back from 'components/Back/Back'
import Slider from './components/Slider/Slider'

import { SLIDES_TEXTS } from './translations'

import { KEY_CODES } from 'constants'

import styles from './MigrationScreen.scss'

const CLAN_NEWS_KEY = 'clanNews'

export class MigrationScreen extends React.Component {
    static propTypes = {
        hideMigrationScreen: PropTypes.func.isRequired,
    }

    componentDidMount = () => {
        setNewsCounter(CLAN_NEWS_KEY, 0)
        window.addEventListener('keydown', this.handleKeyDown)
    }

    componentWillUnmount = () => {
        window.removeEventListener('keydown', this.handleKeyDown)
    }

    handleKeyDown = (e) => {
        if (e.keyCode === KEY_CODES.ESCAPE) {
            this.props.hideMigrationScreen()
        }
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.close}>
                    <Back
                        caption={Back.CAPTIONS.close}
                        handleClick={this.props.hideMigrationScreen}
                        side={Back.SIDES.right}
                        type={Back.TYPES.close}
                    />
                </div>
                <Slider
                    handleClose={this.props.hideMigrationScreen}
                    classNames={{
                        paging: styles.paging,
                        navContainer: styles.navContainer,
                        buttonContainer: styles.buttonContainer,
                    }}
                >
                    {Object.keys(SLIDES_TEXTS).map((slide, index) => {
                        const { title, descriptions } = SLIDES_TEXTS[slide]
                        return (
                            <reactFragment key={slide}>
                                <h1 className={styles.title}>{title}</h1>
                                <div className={styles.content}>
                                    {descriptions.map((description, index) => (
                                        <p className={styles.text} key={index}>
                                            {description}
                                        </p>
                                    ))}
                                    <div className={cx(styles.slideImage, styles[`slideImage__${index + 1}`])} />
                                </div>
                            </reactFragment>
                        )
                    })}
                </Slider>
            </div>
        )
    }
}

export const mapDispatchToProps = {
    hideMigrationScreen,
}

export default connect(null, mapDispatchToProps)(MigrationScreen)



// WEBPACK FOOTER //
// ./containers/MigrationScreen/MigrationScreen.jsx